module.exports = __webpack_public_path__ + "files/606adc74c269c4358a97559e725c1214.png";